/**
 * Wipe every flow's persisted draft (localStorage config + IndexedDB images).
 *
 * Called on sign-out so one user's in-progress uploads/selections never leak
 * to the next user on a shared device. Generic over `ALL_FLOW_KEYS`, so a new
 * flow is covered automatically the moment it's added to the registry.
 */

import { ALL_FLOW_KEYS } from "@/config/flowKeys";
import { clearFlowState } from "@/hooks/useFlowPersistence";
import { clearAllFlowImages } from "@/lib/flowImageStore";

export async function clearAllFlowDrafts(): Promise<void> {
  for (const key of ALL_FLOW_KEYS) clearFlowState(key);
  await clearAllFlowImages();
}
